import React from 'react'
import { WinnersList } from './list/page'

export const GoldenMay2025WinnersPage = () => {
  return <WinnersList />
}
